import {
  EMAIL_ADDRESS,
  LOAN_AMOUNT,
  ORG_NUMBER,
  TERMS_AGREEMENT,
  PHONE_NUMBER,
  LOAN_TERM,
  CLEAR_STATE,
  WEBSITE,
  HOUSE_NUMBER,
  POST_CODE,
  CITY,
  STREET,
  SET_HOME_ADDRESS_REQUEST_STATUS,
  HOUSE_NUMBER_ADDITION,
  CARD_PURPOSE,
  CARD_PURPOSE_ADDITIONAL_INFO,
  TURNOVER,
} from '~/actions/actionTypes';
import { ISignupState } from '~/sharedInterfaces/IState';

const INITIAL_STATE: ISignupState = {};

const signupReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case LOAN_AMOUNT:
    case LOAN_TERM:
      if (parseInt(action.payload, 10) <= Number.MAX_SAFE_INTEGER || !action.payload) {
        return {
          ...state,
          [action.type]: parseInt(action.payload as string, 10),
        };
      }
      return state;

    case HOUSE_NUMBER:
    case HOUSE_NUMBER_ADDITION:
    case POST_CODE:
    case CITY:
    case STREET:
      return {
        ...state,
        homeAddress: {
          ...state.homeAddress,
          [action.type]: action.payload,
        },
      };
    case ORG_NUMBER:
    case TURNOVER:
    case EMAIL_ADDRESS:
    case TERMS_AGREEMENT:
    case PHONE_NUMBER:
    case WEBSITE:
      return {
        ...state,
        [action.type]: action.payload,
      };

    case CLEAR_STATE:
      return {
        ...action.payload,
      };
    case SET_HOME_ADDRESS_REQUEST_STATUS:
      return {
        ...state,
        homeAddress: {
          ...state.homeAddress,
          homeAddressRequestStatus: action.payload,
        },
      };
    case CARD_PURPOSE:
      return {
        ...state,
        cardPurpose: {
          applicationReasons: [
            {
              reason: action.payload,
              reasonText: state.cardPurpose?.applicationReasons?.[0]?.reasonText,
            },
          ],
        },
      };
    case CARD_PURPOSE_ADDITIONAL_INFO:
      return {
        ...state,
        cardPurpose: {
          applicationReasons: [
            {
              reason: state.cardPurpose?.applicationReasons?.[0]?.reason,
              reasonText: action.payload,
            },
          ],
        },
      };
    default:
      return state;
  }
};

export default signupReducer;
